export { default } from './BottomSheetBackdrop';
export type { BottomSheetBackdropProps } from './types';
